import React from 'react'
import PendingDriversSection from '../sections/PendingDriversSection/PendingDriversSection'

const PendingDrivers = () => {
  return (
    <PendingDriversSection />
  )
}

export default PendingDrivers